import { campaignsContract } from '@mntn/api-contracts/flight-deck/v1/campaigns'
import type { ClientInferRequest } from '@ts-rest/core'
import { useFlightDeckTsRestClient } from '@/flight-deck-api/ts-rest'
import { useAuthenticatedSession } from '@/providers/session'

export const useCampaignsService = () => {
  const campaignsClient = useFlightDeckTsRestClient(campaignsContract)
  const { session } = useAuthenticatedSession()

  return {
    findCampaignGroups: {
      handler: async (
        query: Omit<ClientInferRequest<typeof campaignsContract.findCampaignGroups>['query'], 'advertiser-id'>,
      ) => {
        const response = await campaignsClient.findCampaignGroups({
          query: {
            ...query,
            'advertiser-id': session.advertiser.id,
          },
        })
        if (response.status !== 200) {
          throw new Error('There was an issue loading campaigns. Try again.')
        }
        return response.body.data
      },
    },
  }
}
